import { apiClient } from "shared/utils";
import { GetAccountEmailResponse } from "api/models";

export const getAccountEmail = async (key: string) => {
  const { data } = await apiClient.post<GetAccountEmailResponse>(`/create-account`, {
    key
  });

  return data;
};
